/**------------------------------------------------------
 * Interface Definitions
 */
export interface IResizeOptions {
	width 		: number;
	height		: number;
	padding		: number;
}
